import url from 'url';
import compact from 'lodash/compact';
import createSubscribeLink from '../../utils/subscription/createSubscribeLink';
import getGuideItemProducts from '../../utils/guideItem/getGuideItemProducts';

const createAndOpenSubscribeLink = (guideItem, location, products) => {
  const additionalParams = {
    sku: compact(products || getGuideItemProducts(guideItem)),
  };

  window.open(
    url.format(
      createSubscribeLink({
        guideId: guideItem?.guideId,
        location,
        additionalParams,
      }),
    ),
    '_self',
  );
};

export default createAndOpenSubscribeLink;
